import { createReducer } from 'deox';

import * as actions from './actions';

export type ExecutionDateState = string;

export default createReducer(new Date().toISOString(), handle => [
	handle(actions.set, (state, { payload }) => payload.date),
]);
